import type { AcceptedLanguages } from '@payloadcms/translations'

export type LanguageOptions = {
  label: string
  value: AcceptedLanguages
}[]
